import { Model } from '@vuex-orm/core'
import { TaxBreakdown } from './common/breakdown'

export default class AgeGroupPrice extends Model {
  declare id: string
  declare ageGroupID: string
  declare specialOfferAmount: number
  declare taxAmount: number
  declare taxBreakdown: TaxBreakdown
  declare feesAmount: number
  declare totalPrice: number
  declare netPrice: number
  declare ageGroupPriceableId: string
  declare ageGroupPriceableType: string

  static entity = 'ageGroupPrices'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.attr(null),
      ageGroupID: this.attr(null),
      specialOfferAmount: this.number(0),
      taxAmount: this.number(0),
      taxBreakdown: this.attr({}),
      feesAmount: this.attr(0.0),
      totalPrice: this.number(0),
      netPrice: this.number(0),
      ageGroupPriceableId: this.attr(null),
      ageGroupPriceableType: this.attr(null),
    };
  }
}
